import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RBACService } from 'src/app/shared/rbac.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { AuditItemModel } from '../audit-item.model';
import { AuditItemsService } from '../audit-items.service';

@Component({
  selector: 'app-audit-items-edit',
  templateUrl: './audit-items-edit.component.html',
  styleUrls: ['./audit-items-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AuditItemsEditComponent implements OnInit {
  auditItem = new AuditItemModel();

  // RBAC permission flags: resolved once in ngOnInit().
  canEdit: boolean = false;
  canDelete: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private util: UtilsService,
    private router: Router,
    private auditItemService: AuditItemsService,
    private utils: UtilsService,
    public rbac: RBACService
  ) {}

  ngOnInit() {
    this.auditItem.id = Number(this.route.snapshot.params['id']);

    // When editing an existing question, check edit permission: redirect back if denied.
    if (!isNaN(this.auditItem.id)) {
      this.canEdit = this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_REGISTERS_INSPECTIONS_AUDITS,
            RBACService.RBAC_A.A_EDIT
          )
        ],
        true
      );

      if (!this.canEdit) {
        this.rbac.showGenericAccessDeniedMessage(
          'You do not have permission to edit inspection/audit questions.'
        );
        this.router.navigate(['/audit-items']);
        return;
      }

      // Resolve canDelete flag for Delete button visibility.
      this.canDelete = this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_REGISTERS_INSPECTIONS_AUDITS,
            RBACService.RBAC_A.A_DELETE
          )
        ],
        true
      );

      this.auditItemService
        .find(this.auditItem.id)
        .subscribe((response) => (this.auditItem = response.data));
    }
  }

  onSubmit() {
    if (!this.canEdit) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to edit inspection/audit questions.'
      );
      return;
    }

    isNaN(this.auditItem.id) ? this.create() : this.update();
  }

  delete() {
    if (!this.canDelete) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to delete inspection/audit questions.'
      );
      return;
    }

    this.utils.showModal(
      'Remove Question',
      `Are you sure you want to remove the "${this.auditItem.name}" question?`,
      () => {
        this.auditItemService.remove([this.auditItem.id]).subscribe(() => {
          this.utils.showToast(
            `The "${this.auditItem.name}" question was removed.`
          );
          this.router.navigate(['../..'], { relativeTo: this.route });
        });
      }
    );
  }

  private update() {
    this.auditItemService
      .put(this.auditItem)
      .subscribe(() =>
        this.onSuccess(`The "${this.auditItem.name}" question was updated.`)
      );
  }

  private create() {
    this.auditItemService
      .post(this.auditItem)
      .subscribe((response) =>
        this.onSuccess(`The "${response.data.name}" question was created.`)
      );
  }

  private onSuccess(message: string) {
    this.util.showToast(message);
    this.router.navigate(['/audit-items']);
  }
}
